export default "__VITE_ASSET__CgTrxXp3__"